import { hashKey, type QueryClient } from "@tanstack/react-query"

import { queryKeys } from "../services/query-keys"

type SessionExpiryDeps = {
  queryClient: QueryClient
  currentLocation: () => { pathname: string; search: string }
  invalidateRouter: () => void
  redirect: (location: string) => void
}

export function createSessionExpiryHandler({
  queryClient,
  currentLocation,
  invalidateRouter,
  redirect,
}: SessionExpiryDeps): () => void {
  return () => {
    const { pathname, search } = currentLocation()
    if (pathname === "/login") {
      return
    }

    const returnTo = `${pathname}${search}`
    void queryClient.cancelQueries()
    queryClient.setQueryData(queryKeys.authUser, null)
    const authUserQueryHash = hashKey(queryKeys.authUser)
    queryClient.removeQueries({
      predicate: (query) => query.queryHash !== authUserQueryHash,
    })
    queryClient.getMutationCache().clear()
    invalidateRouter()
    redirect(`/login?${new URLSearchParams({ redirect: returnTo }).toString()}`)
  }
}
